import React from "react";

import SearchInput from "./SearchInput";

const AddSevenSendersIntegration = ({ sevenSendersAccessKey, onChange }) => (
  <>
    <SearchInput
      type="text"
      placeholder="Access Key"
      name="sevenSendersAccessKey"
      value={sevenSendersAccessKey}
      onChange={onChange}
    />

    <p className="mt-4 ml-4 font-medium text-xs">
      <span className="text-red-600">Note:</span> {}
      If integration already exists it just returns the same data.
    </p>
  </>
);

export default AddSevenSendersIntegration;
